function berechneGesamtpreis() {
  // Ausgewählter Preis
  var ausgewaehlterPreis = document.getElementById("regular-price").textContent.trim();
  // Entferne das Euro-Zeichen und führende/trailing Leerzeichen
  ausgewaehlterPreis = ausgewaehlterPreis.replace("€", "").trim();
  // Konvertiere den Preis in eine Zahl (float)
  ausgewaehlterPreis = parseFloat(ausgewaehlterPreis.replace(",", ".")); // ggf. Punkt statt Komma verwenden

  // Aktuelle Menge
  var aktuelleMenge = parseFloat(document.querySelector(".kb-quantity_input_berechnen").value);

  // Gesamtpreis berechnen
  var gesamtpreis = ausgewaehlterPreis * aktuelleMenge;
  gesamtpreis = gesamtpreis.toFixed(2) + " €";
  gesamtpreis = gesamtpreis.replace(".", ",");

  // Gesamtpreis anzeigen
  var currentPriceFront = document.getElementById("kb-product-quote-current-price");
  currentPriceFront.innerHTML = gesamtpreis;
}

document.addEventListener("DOMContentLoaded", function() {
    berechneGesamtpreis();
});

var rentalDurationRadios = document.querySelectorAll('input[name="Bérlési idő"]');
rentalDurationRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
        // Wenn sich die Auswahl ändert, rufe die Funktion zur Berechnung des Gesamtpreises auf
        setTimeout(berechneGesamtpreis, 800);
    });
});